import type { Project } from '../../api/client'

interface MoveToProjectControlProps {
  currentProjectId: string | null | undefined
  projects: Project[]
  onMove: (projectId: string | null) => void
}

export function MoveToProjectControl({ currentProjectId, projects, onMove }: MoveToProjectControlProps) {
  return (
    <div className="flex items-center gap-1.5">
      <span className="text-xs text-gray-400 shrink-0">Project:</span>
      <select
        value={currentProjectId ?? ''}
        onChange={e => onMove(e.target.value || null)}
        className="text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:ring-1 focus:ring-indigo-400 max-w-[120px] truncate"
      >
        <option value="">None</option>
        {projects.map(p => (
          <option key={p.id} value={p.id}>{p.name}</option>
        ))}
      </select>
    </div>
  )
}
